"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _api = require("../../api");
var _CardForm = require("../CardForm");
var _Translated = _interopRequireDefault(require("../Translated"));
var _stripe = require("../../stripe");
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _useStripePromise = _interopRequireDefault(require("../../hooks/useStripePromise"));
var _hooks = require("../../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PaymentMethodForm = _ref => {
  let {
    onCancel,
    onSuccess,
    errorMessage,
    requestInProgress,
    defaultPaymentMethod,
    submitButtonProps = {},
    buttonsContainerProps = {},
    showDescriptionText = false,
    submitButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "save"
    }),
    cancelButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "cancel"
    }),
    customer,
    addressDisabled: isAddressDisabled = false
  } = _ref;
  const {
    stripePublicKey
  } = (0, _hooks.useConfig)();
  const [countryCode, setCountryCode] = (0, _react.useState)('');
  const [zipCode, setZipCode] = (0, _react.useState)('');
  const onCountryCodeChange = e => {
    setCountryCode(e.target.value);
  };
  const onZipCodeChange = e => {
    setZipCode(e.target.value);
  };
  const stripePromise = (0, _useStripePromise.default)(stripePublicKey);
  const policyLinks = (0, _hooks.usePolicyLinks)();
  return /*#__PURE__*/_react.default.createElement(_stripe.Elements, {
    stripe: stripePromise
  }, showDescriptionText && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    values: policyLinks,
    id: "subscribe_card_text"
  })), errorMessage && /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: errorMessage
  })), /*#__PURE__*/_react.default.createElement(_CardForm.CardForm, {
    onCancel: onCancel,
    onSuccess: onSuccess,
    apiRequest: _api.attachPaymentMethod,
    cancelButtonText: cancelButtonText,
    submitButtonText: submitButtonText,
    requestInProgress: requestInProgress,
    submitButtonProps: submitButtonProps,
    defaultPaymentMethod: defaultPaymentMethod,
    buttonsContainerProps: buttonsContainerProps,
    customer: customer,
    addressDisabled: isAddressDisabled,
    countryCode: countryCode,
    onCountryCodeChange: onCountryCodeChange,
    zipCode: zipCode,
    onZipCodeChange: onZipCodeChange
  }));
};
var _default = exports.default = PaymentMethodForm;